import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  useTheme,
} from '@mui/material';

import { HexColorPicker } from 'react-colorful';

const ColorBoxModal = ({ onChange, currentColor, handleClose, open }) => {
  const theme = useTheme();

  const [selectedColor, setSelectedColor] = useState(currentColor);

  useEffect(() => {
    console.log(currentColor);
    setSelectedColor(currentColor);
  }, [currentColor]);

  const handleOk = () => {
    onChange(selectedColor);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={theme.custom.dialogColor}>Escolha uma cor</DialogTitle>
      <DialogContent dividers sx={theme.custom.dialogColor}>
        <div
          style={{
            padding: theme.spacing(2),
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <HexColorPicker
            sx={{ margin: theme.spacing(2) }}
            color={selectedColor}
            onChange={setSelectedColor}
          />
        </div>
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'space-around',
          }}
        >
          <TextField
            value={selectedColor}
            disabled
            variant='outlined'
            size='small'
            fullWidth
            slotProps={{
              readOnly: true,
            }}
            sx={theme.custom.textField}
          />
          <Box
            style={{
              width: 80,
              height: 40,
              backgroundColor: `${selectedColor}`,
              justifySelf: 'center',
              borderRadius: 4,
            }}
          />
        </div>
      </DialogContent>

      <DialogActions sx={theme.custom.dialogColor}>
        <Button
          onClick={handleClose}
          variant='outlined'
          sx={theme.custom.cancelButton}
        >
          Cancelar
        </Button>
        <Button
          variant='outlined'
          sx={theme.custom.confirmButton}
          onClick={handleOk}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ColorBoxModal;
